import { CowOffIcon } from './CowOffIcon';

/**
 * author: Michael Irigoyen
 * id 8FA2AEE7-EBCA-4943-AF59-FF3C4D762C53
 * name cow-off
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cow-off.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 * - Animal 
 */
export const DairyFreeIcon = CowOffIcon;
export default DairyFreeIcon